import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import LoteGestion from './view/LoteGestion'

// const LoteRegistroApp = lazy(() => import('./view/LoteRegistro'))

export const loteRoutesMap = {
  gestion: {
    path: '/lote/gestion',
    name: 'Lotes',
    action: 'LOTES',
  },
  registro: {
    path: '/lote/nuevo',
    name: 'Nuevo lote',
    action: 'ADMINISTRAR_LOTES',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const loteRoutes = [
  {
    path: loteRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <LoteGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: loteRoutesMap.upsert.path,
    element: <LoteRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default loteRoutes
